
<template>
  <div id="app">
    <router-view
        class="center"
        style="height: 100%;"
    ></router-view>
  </div>
</template>


<script>
import {Shares} from '@/util/Share'
import {getExpirationTime} from '@/service/invitationClientApis'
import moment from "moment";
export default {
  name: 'app',
  data() {
    return {
      expirationed:false
    }
  },
  methods: {
    getWindowConfig() {
      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      if (typeof windowWidth !== 'number') {
        if (document.compatMode === 'CSS1Compat') {
          windowWidth = document.documentElement.clientWidth;
          windowHeight = document.documentElement.clientHeight;
        } else {
          windowWidth = document.body.clientWidth;
          windowHeight = window.body.clientHeight;
        }
      }
      return {
        windowWidth: windowWidth,
        windowHeight: windowHeight
      }
    }
  },
  mounted() {},
  created() {
    if (this.$route.path.includes('invitationLetter2026')) {
      // this.expirationed = moment(new Date()).isAfter(moment(new Date('2025-02-18T10:45:35')))
      // if(this.expirationed && this.$route.name !== 'invitationLetterComplete2025') {
      //   this.$router.replace({path:"/invitationLetterComplete2025"})
      // }
      getExpirationTime().then(res=>{
        if(res.code === '0'){
          this.expirationed = moment(new Date()).isAfter(moment(new Date(res.expiration_time)))
          if(this.expirationed && this.$route.name !== 'invitationLetterComplete2025') {
            this.$router.replace({path:"/invitationLetterComplete2025"})
          }
        }
      })
    }

    Shares.initRealAuthUrl()
  },
  watch:{
    '$route'(to, from) {
      // todo  微信端 删除 直销管理 到 预约详情的缓存
      if(this.expirationed && to.name !== 'invitationLetterComplete2025') {
        this.$router.replace({path:"/invitationLetterComplete2025"})
      }
    }
  },
  destroyed() {
    Shares.clearRealAuthUrl()
  }
}
</script>

<style>
/*html,body{*/
/*  height: 100%;*/
/*}*/
#app {
  /*height: 100vh;*/
  overflow: auto;
}

@media screen and (min-width: 1024px) {
  html, body {
    height: 100%;
  }

  #app {
    height: 100%;
    overflow: auto;
  }

  #app > div {
    overflow: hidden;
  }
}

.defatult-bg {
  background-image: url("./assets/2025/client-form-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-color: rgb(8 34 109);
}

</style>

